import { useNavigate } from 'react-router-dom';
import { homepageArticles } from '@/mocks/articles';

export default function ArticleHub() {
  const navigate = useNavigate();

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-body tracking-wide">
            SEO Resources
          </span>
          <h2 className="mt-4 text-3xl md:text-5xl font-bold text-foreground-950 font-heading leading-tight">
            Hipobuy Spreadsheet<br />
            <span className="italic font-normal text-secondary-500">Guides & Articles</span>
          </h2>
          <p className="mt-4 text-sm text-foreground-600 font-body max-w-lg">
            In-depth guides, comparison reviews, category deep dives, and expert tutorials to help you master product discovery, quality verification, and smart shopping strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {homepageArticles.map((article) => (
            <div
              key={article.id}
              className="bg-background-50 rounded-2xl p-6 border border-background-200 flex flex-col hover:border-accent-200 transition-colors duration-200"
            >
              <div className="flex items-start justify-between mb-4">
                <span className={`w-10 h-10 flex items-center justify-center rounded-xl ${
                  article.categoryColor === 'accent'
                    ? 'bg-accent-100 text-accent-600'
                    : 'bg-secondary-100 text-secondary-600'
                }`}>
                  <i className="ri-article-line text-lg"></i>
                </span>
                <div className="flex flex-col items-end">
                  <span className="text-[11px] text-foreground-400 font-body">{article.date}</span>
                  <span className="text-[11px] text-foreground-500 font-body">{article.category}</span>
                </div>
              </div>

              <h3 className="text-base font-semibold text-foreground-900 font-body leading-snug mb-3">
                {article.title}
              </h3>

              <p className="text-sm text-foreground-600 font-body leading-relaxed mb-5 flex-1">
                {article.summary}
              </p>

              <div className="flex items-center gap-4 pt-4 border-t border-background-100">
                <button
                  onClick={() => navigate(`/article/${article.id}`)}
                  className="text-sm font-medium text-accent-600 hover:text-accent-700 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Read Article <i className="ri-arrow-right-line ml-1"></i>
                </button>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
                  className="text-xs text-foreground-400 hover:text-foreground-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Back to Hub
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-100 text-accent-700 text-sm font-semibold hover:bg-accent-200 transition-colors cursor-pointer whitespace-nowrap"
          >
            Browse All Hipobuy Spreadsheet Guides
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}